<section class="container">

  <div class="row">
    <div class="col">
      <h3>Cadastro de faixa de carteira PJ</h3>
    </div>

    <div class="col-auto">
      <button type="button" class="btn btn-danger no-margin" (click)="voltarParaLista()">
        Cancelar
      </button>
    </div>

    <div class="col-auto">
      <button [disabled]="!idAgenteFinanceiro || !valorFaixa || !idTranche" type="button"
        class="btn btn-primary no-margin" (click)="salvar()">
        Salvar
      </button>
    </div>
  </div>

  <div class="row">

    <div class="bn-form-group col-md-6">
      <label><b>Agente Financeiro:</b></label>
      <select class="form-select" [(ngModel)]="idAgenteFinanceiro">
        <option [ngValue]="undefined" selected></option>
        <option *ngFor="let agente of agentesFinanceiros" [ngValue]="agente.id">{{ agente.nome + ' (' + agente.cnpj + ')' }}</option>
      </select>
    </div>

    <div [ngClass]="(mostrarLabel ? 'col-md-3' : 'col-md-6')">
      <label for="tranche"><b>Cesta:</b></label>
      <select id="tranche" class="form-select" [(ngModel)]="idTranche" disabled>
        <option [ngValue]=null></option>
        <option [ngValue]="tranche.id" *ngFor="let tranche of tranches">
          {{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
      </select>
    </div>

    <div class="bn-form-group col-md-3 justify-content-end" style="display: flex; align-items: center; margin-top: 1.5em;" >
      <label-participantes-conglomerado 
        [idAgenteFinanceiro]="idAgenteFinanceiro" 
        (mostraLabel)="mostraLabel($event)">
      </label-participantes-conglomerado>
    </div>

  </div>

  <div class="row">
    <div class="bn-form-group col-md-6">
      <label><b>Faixa:</b></label>
      <select id="numeroFaixa" class="form-select" [(ngModel)]="valorFaixa">
        <option [ngValue]="undefined" selected></option>
        <option *ngFor="let valor of valoresFaixaCarteira" [ngValue]="valor">{{ valor.labelFaixa }}</option>
      </select>
    </div>

    <div class="col-md-6">
      <label><b>Data de Início</b></label>
      <bn-datepicker disabled name="dataInicio" [(ngModel)]="dataInicioValidade" [ngModelOptions]="{standalone: true}">
      </bn-datepicker>
    </div>
  </div>

</section>